import { Checkbox, DatePicker, Form, Input, Row, FormInstance } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useButtonHandlers } from "../hooks/useButtonHandlers";
import { FormButtons } from "../../../../../../../components/DefaultFormButtons";
import { DATE_FORMAT } from "../../../../../../../lib/constants";
import { useGetInitialValues } from "../hooks/useGetInitialValues";
import { Loader } from "../../../../../../../components/Loader";
import { UploadFileFormItem } from "./UploadFileFormItem";
import { useSetMissingFileError } from "../../../../../../../lib/hooks/useSetMissingFileError";
import { useRules } from "../hooks/useRules";
import { VisibilityFormItem } from "./VisibilityFormItem";

type TFormProps = {
  id: string | null;
  reloadData: () => void;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setId: React.Dispatch<React.SetStateAction<string | null>>;
  parentId?: string;
};

export const DocumentsForm = ({
  id,
  reloadData,
  setIsOpen,
  setId,
  parentId,
}: TFormProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const {
    isFormDisabled,
    onCancelBtnClick,
    onSaveBtnClick,
    onDeleteBtnClick,
    setIsFormDisabled,
  } = useButtonHandlers({ reloadData, setIsOpen, setId, form, parentId });

  const { isLoading, initialValues } = useGetInitialValues(id, form);

  useSetMissingFileError(form, "file");

  const { dateRule, nameRule, descriptionRule } = useRules();

  return (
    <Row className="h-100 position-relative flex-column">
      {isLoading ? (
        <Loader fontSize="64px" />
      ) : (
        <>
          <Form
            form={form}
            layout="vertical"
            requiredMark={false}
            className="pa-6 payee-disbursements-form overflow-y-auto"
            disabled={isFormDisabled}
            initialValues={initialValues}
          >
            <UploadFileFormItem
              setIsLoading={setIsFormDisabled}
              uploadType={1}
            />
            <Form.Item
              name="date"
              label="Date"
              className="mb-6 w-100"
              rules={dateRule}
            >
              <DatePicker format={DATE_FORMAT} placeholder="MM/DD/YY" />
            </Form.Item>
            <Form.Item
              name="name"
              label="Name"
              className="mb-6 w-100"
              rules={nameRule}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="description"
              label="Description"
              className="mb-6 w-100"
              rules={descriptionRule}
            >
              <TextArea rows={1} />
            </Form.Item>
            <Form.Item
              name="isHolding"
              valuePropName="checked"
              className="mb-6 w-100"
            >
              <Checkbox>Holding Original</Checkbox>
            </Form.Item>
            <VisibilityFormItem form={form} />
          </Form>
          <FormButtons
            currentId={id}
            onSaveClick={onSaveBtnClick}
            onCancelClick={onCancelBtnClick}
            onDeleteClick={onDeleteBtnClick}
            isFormDisabled={isFormDisabled}
            controller="ContractDocuments"
          />
        </>
      )}
    </Row>
  );
};
